import {
  isFeatureFlagEnabled,
  type FeatureFlag,
  type FeatureFlagState,
  type UseFeatureFlagUtilsResult,
} from '@onesource/components';
import { z } from 'zod';

export const EFeatureFlagKey = z.enum([
  'SHOW_ADDON_APP',
  'SHOW_COMMUNITY_WIDGETS',
  'SHOW_LOCKED_SPACES',
  'SHOW_PRO_DIRECTORY',
]);
export const EFeatureFlagEnum = EFeatureFlagKey.enum;
export type TFeatureFlagKey = z.infer<typeof EFeatureFlagKey>;

export const FEATURE_FLAGS_FOR_UI: FeatureFlag[] = [
  {
    key: EFeatureFlagEnum.SHOW_COMMUNITY_WIDGETS,
    label: 'Show Community Widgets',
    defaultValue: false,
    description:
      'Show the Trending Tags, Community Stats and Top Contributors cards in the community feed sidebar (and their tabs in the mobile details sheet).',
  },
  {
    key: EFeatureFlagEnum.SHOW_LOCKED_SPACES,
    label: 'Show Locked Spaces',
    defaultValue: false,
    description: 'Show locked/inaccessible spaces on the apps page and navigation',
  },
  {
    key: EFeatureFlagEnum.SHOW_PRO_DIRECTORY,
    label: 'Show Pro Directory',
    defaultValue: false,
    description: 'Show the Pro Directory tab on the My Account page',
  },
] as const;

export { isFeatureFlagEnabled };
export type { FeatureFlag, FeatureFlagState, UseFeatureFlagUtilsResult };
